export class ScaledAssessment {
    assessmentId: number;
    assessmentName: string;
    assessmentNameLatin: string;
    className: string;
    classNameEn: string;
    sectionName: string;
    sectionNameEn:  string;
    assessmentScaleId: number;
    sectionSubjectId: number;
    statusId: number;
    subjectName: string;
    subjectNameEn: string;             
}